import React, { Fragment } from "react";
import { useCreateContract } from "../../Hooks/index";
import { useNavigate } from "react-router";
import Form from "../../Components/Form";
import CustomModal from "../../../../Common/Modal/CustomModal";
import { data } from "jquery";
import { Helmet } from "react-helmet";
function Index() {
  const navigate = useNavigate();
  const {
    step,
    setStep,
    setData,
    data,
    modal,
    setModal,
    CreateContract,
    loading,
  } = useCreateContract();
  return (
    <>
      <Helmet>
        <title>نیکوتن | ثبت قرارداد </title>
      </Helmet>
      <div
        style={{ width: "100vw", height: "100vh" }}
        className="d-flex justify-content-center align-items-center my-3"
      >
        <Form
          setData={setData}
          data={data}
          setStep={setStep}
          step={step}
          CreateContract={CreateContract}
          loading={loading}
        />
        <CustomModal
          show={modal.visible}
          handleClose={() => {
            setModal(() => setModal({ ...modal, visible: false }));
            navigate("/site/contract");
          }}
          size={"md"}
          header={"نتیجه ثبت"}
        >
          <Modal data={modal.data} />
        </CustomModal>
      </div>
    </>
  );
}

export default Index;

const Modal = ({ data }) => {
  return (
    <div className="row justify-content-center ">
      <div className="col-12">
        <div
          className="d-flex justify-content-evenly card-header  rounded-5 py-3 mt-1"
          style={{ backgroundColor: "#88CE66 ", marginBottom: "18px" }}
        >
          <div>
            <span style={{ fontWeight: "bolder" }}>کد پیگیری قراداد</span>
          </div>
          <div>
            <span style={{ fontWeight: "bolder" }}>{data.trackingnumber}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
